import { render, staticRenderFns } from "./BoxCaseForm.vue?vue&type=template&id=56ef8fbd&scoped=true&"
import script from "./BoxCaseForm.vue?vue&type=script&lang=ts&"
export * from "./BoxCaseForm.vue?vue&type=script&lang=ts&"
import style0 from "./BoxCaseForm.vue?vue&type=style&index=0&id=56ef8fbd&prod&lang=postcss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "56ef8fbd",
  null
  
)

export default component.exports

/* nuxt-component-imports */
installComponents(component, {CustomTooltip: require('/opt/atlassian/pipelines/agent/build/components/CustomTooltip.vue').default})
